import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import "../styling/sidebar.css";
import "../styling/incomepop.css";
import GetUser from "../services/get-user";

export default function IUPopup(props) {
  const [name, setName] = useState(props.keydata.name);
  const [revenue, setRevenue] = useState(props.keydata.revenue);
  const [stream, setStream] = useState(props.stream + 1);
  const [source, setSource] = useState(props.keydata.source);
  const [note, setNote] = useState(props.keydata.note);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const user = GetUser();

  const platformName: any = [
    {
      value: "Etsy",
      label: "Etsy",
    },
    {
      value: "Poshmark",
      label: "Poshmark",
    },
    {
      value: "Depop",
      label: "Depop",
    },
    {
      value: "Shopify",
      label: "Shopify",
    },
    {
      value: "StockX",
      label: "StockX",
      subOption: [
        {
          value: "Level 1",
          label: "Level 1",
        },
        {
          value: "Level 2",
          label: "Level 2",
        },
        {
          value: "Level 3",
          label: "Level 3",
        },
        {
          value: "Level 4",
          label: "Level 4",
        },
        {
          value: "Level 5",
          label: "Level 5",
        },
      ],
    },
    {
      value: "GOAT",
      label: "GOAT",
    },
    {
      value: "eBay",
      label: "eBay",
    },
    {
      value: "Instagram",
      label: "Instagram",
    },
    {
      value: "Facebook Marketplace",
      label: "Facebook Marketplace",
    },
    {
      value: "Grailed",
      label: "Grailed",
    },
    {
      value: "Mercari",
      label: "Mercari",
    },
    {
      value: "My own website",
      label: "My own website",
    },
    {
      value: "Alias",
      label: "Alias",
    },
    {
      value: "Vinted",
      label: "Vinted",
    },
    {
      value: "OfferUp",
      label: "OfferUp",
    },
    {
      value: "Custom",
      label: "Custom",
    },
  ];

  function validateForm() {
    return name.length > 0 && source.length > 0 && revenue >= 0;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      //'http://localhost:8080/income/add_income'
      //return axios.post('http://localhost:8080/income/update_income', {
      return axios
        .post("https://sotira-back-test.herokuapp.com/income/update_income", {
          userID: user.userID,
          source,
          note,
          income: revenue,
          iname: name,
          stream: stream,
        })
        .then((response) => {
          setLoading(false);
          props.closeUpdateIncome(false);
          props.setReloadTableData((prevState) => !prevState);
        });
    } catch (e: any) {
      alert(e.message);
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="name" className="form-group required">
        <Form.Label className="control-label"> Name </Form.Label>
        <Form.Control
          autoFocus
          type="name"
          value={name}
          required
          onChange={(e) => setName(e.target.value)}
        />
      </Form.Group>

      <Form.Group controlId="source" className="form-group required">
        <Form.Label className="control-label"> Source </Form.Label>
        <input
          autoFocus
          type="text"
          value={source}
          required
          onChange={(e) => setSource(e.target.value)}
          className="form-control"
          list="source"
        />
        <datalist id="source">
          {platformName.map((item: any) => (
            <option key={item.label} value={item.value} />
          ))}
        </datalist>
      </Form.Group>

      <Form.Group controlId="note" className="form-group">
        <Form.Label className="control-label"> Note </Form.Label>
        <Form.Control
          autoFocus
          type="note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </Form.Group>

      <Button block size="sm" type="submit" disabled={!validateForm()}>
        {loading ? (
          <>
            <CircularProgress className="file-loader mr-3" />
            Updating
          </>
        ) : (
          " Edit Stream"
        )}
      </Button>
    </Form>
  );
}
